import { AxiosResponse } from "axios"
import { z } from "zod"

import { axios } from "@/shared/lib/axios"

import { loginSchema } from "../hooks/useLogin"

export type LoginResponse = {
  meta: {
    code: number;
    status: string;
    message: string;
  };
  data: {
    token: string;
    refreshToken: string;
    sso_token?: string;
  };
}

const login = ({ ...data }: z.infer<typeof loginSchema>): Promise<AxiosResponse<LoginResponse>> => {
  return axios.post("/auth/login", {
    emailOrUsername: data.emailOrUsername,
    password: data.password,
  }, {
    headers: {
      "Device-Type": "desktop",
      "App-Name": "e-signature",
    }
  })
}

export const Logout = async () => {
  try {
    const res = await axios.post("/logout", {})
    return res.data
  } catch (error) {
    return error
  }
}

export const ForgetPassword = async (_key: string, data: { email: string }) => {
  try {
    const res = await axios.post("/forgot-password", data)
    return res.data
  } catch (error) {
    return error
  }
}

export const ResetPassword = async (
  _key: string,
  data: {
    password: string;
    password_confirmation: string;
    email: string | null;
    token: string | string[] | undefined;
  }
) => {
  try {
    const res = await axios.post("/reset-password", data)
    return res.data
  } catch (error) {
    return error
  }
}

export { login }
